import { mapGetters } from 'vuex'
import Toast from '../Toast/index'
// import $ from 'jquery'
export default {
  name: 'QuickLinks',
  components: { Toast },
  props: ['device'],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'quickLinks',
      'userType'
    ])
  },
  mounted () {
    this.$store.dispatch('quickLinks')
  },
  methods: {
    generateSlug (label) {
      var labelArr = label.split(' ')
      return (labelArr.join('-')).toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/QuickLinks/component.js